// feat_305 — Nombre visible del contacto. Criterio ÚNICO para zócalo
// (TicketListItem), header del chat (TicketInfo) y listado de Contactos.
//
// Espeja el criterio que ya existía en el backend
// (services/EmailServices/TicketReportEmailService.ts: name+lastName ->
// whatsappName -> number) y le suma la empresa. NO inventar un criterio nuevo:
// si hace falta cambiar la regla, se cambia acá y las tres vistas la siguen.
//
// Reglas:
//   base    = "name lastName" (los que existan) -> whatsappName -> number
//   empresa = " — organization", SOLO si hay base, hay organization y NO es grupo
//   sin nada -> opts.fallback (default "")
//
// Campos del modelo Contact: `lastName` (apellido) y `organization` (empresa),
// ambos columnas reales nullable. NO existe ningún campo `company` en Contact
// (`companyId` es el FK multi-tenant, otra cosa).
//
// Grupos: ningún flujo automático de WhatsApp escribe lastName/organization,
// pero un humano PUEDE editarlos desde ContactModal; con isGroup=true se
// ignoran a propósito (el `name` del grupo es el asunto, el guion no aporta).
// `isGroup` llega por opts porque los includes de contact de
// ListTicketsService/ShowTicketService no traen esa columna — en tickets se
// pasa `ticket.isGroup`, que sí existe en el modelo Ticket.

const EM_DASH = "—";

export const getContactDisplayName = (contact, opts = {}) => {
  if (!contact) return opts.fallback || "";
  const { isGroup = !!contact.isGroup, withOrganization = true, fallback = "" } = opts;

  const base =
    [contact.name, contact.lastName].filter(v => v && String(v).trim()).join(" ").trim() ||
    (contact.whatsappName || "").trim() ||
    (contact.number || "").trim();

  if (!base) return fallback;

  const org = (contact.organization || "").trim();
  if (!withOrganization || isGroup || !org) return base;

  return `${base} ${EM_DASH} ${org}`;
};

export default getContactDisplayName;
